<template>
  <v-container fluid>
    <v-card class="ma-1" tile elevation="0">
      <v-row no-gutters>
        <!-- LISTA DE CHATS -->
        <v-col cols="12" md="3">
          <v-toolbar color="blue-grey lighten-1" dark tile elevation="0">
            <v-toolbar-title>Mensajes</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="listarChats()">
              <v-icon>fas fa-sync-alt</v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
          </v-toolbar>
          <v-list
            three-line
            color="blue-grey lighten-4"
            style="max-height: 700px"
            class="overflow-y-auto"
          >
            <template>
              <v-list-item-group>
                <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                  @click="verMensajes(item)"
                >
                  <v-list-item-avatar color="grey">
                    <v-img :src="require('@/assets/no_logo_user.png')"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>
                      <span
                        v-html="
                          item.nombre_contacto
                            ? item.nombre_contacto
                            : item.numero_contacto
                        "
                      ></span>
                    </v-list-item-title>
                    <v-list-item-action class="ma-0">
                      <v-spacer></v-spacer>
                      <span class="caption"
                        >Tel: {{ item.numero_contacto }}</span
                      >
                    </v-list-item-action>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </template>
          </v-list>
        </v-col>
        <v-col cols="12" md="9">
          <v-row no-gutters>
            <v-col cols="12">
              <v-toolbar color="blue-grey lighten-1" dark tile elevation="0">
              </v-toolbar>
            </v-col>
            <v-col cols="12">
              <v-card
                tile
                elevation="0"
                height="700px"
                style="display: flex !important; flex-direction: column"
              >
                <v-card-text
                  style="flex-grow: 1; overflow: auto"
                  class="scrollable"
                  ref="msgContainer"
                  v-if="items_chat != 0"
                >
                  <v-row v-for="(item, i) in items_chat" :key="i" no-gutters>
                    <v-col md="auto" class="my-1" v-if="item.tipo_usuario == 1">
                      <v-card class="pa-2" outlined color="blue-grey lighten-4">
                        <span>{{ item.mensaje }}</span>
                        <v-card-actions class="pa-0">
                          <v-spacer></v-spacer>
                          <span class="caption mr-1">{{
                            formatoFecha(item.fecha_mensaje)
                          }}</span>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col md="auto" class="my-1" v-if="item.tipo_usuario == 2">
                      <v-card
                        class="pa-2"
                        outlined
                        color="blue-grey lighten-4"
                        max-width="700"
                      >
                        <span style="white-space: pre">{{ item.mensaje }}</span>
                        <v-card-actions class="pa-0">
                          <v-spacer></v-spacer>
                          <span class="caption mr-1">{{
                            formatoFecha(item.fecha_mensaje)
                          }}</span>
                          <v-icon small v-if="item.estado == 'sent'"
                            >fa-solid fa-check</v-icon
                          >
                          <v-icon small v-if="item.estado == 'delivered'"
                            >fa-solid fa-check-double</v-icon
                          >
                          <v-icon
                            small
                            color="blue"
                            v-if="item.estado == 'read'"
                            >fa-solid fa-check-double</v-icon
                          >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                small
                                color="red"
                                v-if="item.estado == 'failed'"
                                v-bind="attrs"
                                v-on="on"
                                @click="enviarMensajeOtraVez(item)"
                                >fas fa-exclamation-circle</v-icon
                              >
                            </template>
                            <span>{{ item.mensaje_error }}</span>
                          </v-tooltip>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text
                  v-else
                  style="flex-grow: 1; overflow: auto"
                  class="scrollable"
                  ref="msgContainer"
                >
                  <h1 class="text-center">No hay mensajes aún...</h1>
                  <v-img
                    :src="require('@/assets/icon_empty.jpg')"
                    width="200"
                    class="mx-auto mt-3"
                  ></v-img>
                </v-card-text>
                <v-footer elevation="0" tile v-if="items_chat != 0">
                  <v-text-field
                    v-model="mensaje_chat"
                    label="Escribir mensaje"
                    counter="4096"
                    maxlength="4096"
                    single-line
                    outlined
                    dense
                    hide-details
                    @keyup.enter="EnviarMensaje()"
                    @input="envioPlantillas()"
                  >
                  </v-text-field>
                </v-footer>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-bottom-sheet v-model="sheet" inset>
      <v-sheet class="text-center" height="200px">
        <v-btn class="mt-6" text color="error" @click="sheet = !sheet">
          Cerrar
        </v-btn>
        <v-list dense nav>
          <v-list-item
            v-for="tile in lista_plantillas"
            :key="tile.id"
            @click="sheet = false"
          >
            <v-list-item-title>{{ tile.titulo }}</v-list-item-title>
            <v-list-item-action>
              <v-icon color="grey lighten-1">fas fa-paper-plane</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
const signalR = require("@microsoft/signalr");

export default {
  data: () => ({
    items: [],
    items_chat: [],
    mensaje_chat: "",
    connection: "",
    numero_contacto: "",
    sheet: false,
    lista_plantillas: [
      {
        id: 1,
        titulo: "SALUDO",
        mensaje: "Hola le escribimos de asistencia regional.",
      },
      { id: 2, titulo: "MENSAJE CORTO", mensaje: "" },
    ],
  }),
  mounted() {
    this.connection.on("Receive", (model) => {
      //console.log("Hola", model);
      this.listarChats();
      this.verActualizacionMensaje();
    });
  },
  created() {
    this.listarChats();
    this.esuchadorApi();
  },
  methods: {
    listarChats() {
      axios.get("api/WhatsAppApiContactos/Listar").then((response) => {
        //console.log(response.data);
        this.items = response.data;
      });
    },
    verMensajes(item) {
      this.numero_contacto = item.numero_contacto;
      axios
        .get("api/WhatsAppApi/Listar/" + item.numero_contacto)
        .then((response) => {
          //console.log(response.data);
          this.items_chat = response.data;
          this.onScroll();
        });
    },
    verActualizacionMensaje() {
      axios
        .get("api/WhatsAppApi/Listar/" + this.numero_contacto)
        .then((response) => {
          //console.log(response.data);
          this.items_chat = response.data;
          this.onScroll();
        });
    },
    EnviarMensaje() {
      this.items_chat.push({
        id: this.items_chat.length + 1,
        tipo_usuario: "2",
        mensaje: this.mensaje_chat,
      });

      axios
        .post("api/WhatsAppApi/enviarMensaje", {
          id_usuario: this.$store.state.usuario.idUsuario,
          messaging_product: "whatsapp",
          recipient_type: "individual",
          to: this.numero_contacto,
          type: "text",
          text: {
            body: this.mensaje_chat,
          },
        })
        .then((response) => {
          //console.log("RESPONSE ", response.data);
          if (response.data.error) {
            return this.alertaError(
              "Mensaje no se pudo enviar motivo: " + response.data.error.message
            );
          }
          if (
            response.data.messaging_product == "whatsapp" &&
            response.data.messages[0].message_status == "accepted"
          ) {
            return this.alertaCorrecto(
              "Mensaje enviado correctamente: Para dar seguimiento ir a modulo de WhatsApp"
            );
          }
        });

      this.mensaje_chat = "";
      this.onScroll();
    },
    enviarMensajeOtraVez(item) {
      //console.log(item);
      axios
        .post("api/WhatsAppApi/reenviarMensaje", {
          id_wa_api: item.id_wa_api,
          id_usuario: this.$store.state.usuario.idUsuario,
          messaging_product: "whatsapp",
          recipient_type: "individual",
          to: this.numero_contacto,
          type: "text",
          text: {
            body: item.mensaje,
          },
        })
        .then((response) => {
          console.log("RESPONSE REENVIO", response.data);
          if (response.data.error) {
            return this.alertaError(
              "Mensaje no se pudo enviar motivo: " + response.data.error.message
            );
          }
          if (
            response.data.messaging_product == "whatsapp" &&
            response.data.messages[0].message_status == "accepted"
          ) {
            return this.alertaCorrecto(
              "Mensaje enviado correctamente: Para dar seguimiento ir a modulo de WhatsApp"
            );
          }
        });
    },
    onScroll() {
      this.$nextTick(function () {
        var container = this.$refs.msgContainer;
        container.scrollTop = container.scrollHeight + 120;
      });
    },
    formatoFecha(fecha) {
      return moment(fecha).format("DD/MM/YYYY HH:mm:ss");
    },
    esuchadorApi() {
      this.connection = new signalR.HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl(process.env.VUE_APP_AXIOS + "/callWhatsAppApi", {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .build();

      this.connection
        .start()
        .then(() => {
          console.log("Conexión establecida");
        })
        .catch(() => {
          console.log("No se pudo conectar");
        });
    },
    alertaError(mensaje) {
      this.$toast.error(mensaje, {
        position: "top-right",
        closeOnClick: false,
        draggable: false,
        timeout: 10000,
      });
    },
    alertaCorrecto(mensaje) {
      this.$toast.success(mensaje, {
        position: "top-right",
        closeOnClick: false,
        draggable: false,
        timeout: 10000,
      });
    },
    envioPlantillas() {
      if (this.mensaje_chat == ">") {
        this.sheet = true;
      }
    },
  },
};
</script>

<style>
.scroll {
  display: flex !important;
  flex-direction: column;
  overflow-y: auto;
}
.scrollable {
  overflow: hidden;
  overflow-y: scroll;
  height: calc(100vh - 20px);
}
</style>